function Filter() {
  return function(input) {
    if (!input) return null;

    const numString = input.toString();
    const length = (numString).substring(numString.indexOf('.') + 1).length;

    let precision = (length < 2 ? 0 : length - 2);

    if (numString.indexOf('.') === -1) {
      precision = 0;
    }

    const final = `${(input * 100).toFixed(precision)}%`;

    return final;
  };
}

Filter.$inject = [];

export default Filter;



// WEBPACK FOOTER //
// ./src/filters/percentageFilter.js